import { Component, Input } from '@angular/core';
import { ViewService } from '../../view.service';


@Component({
    selector: 'comission',
    templateUrl: './comission.component.html',
    styleUrls: ['./comission.component.scss']
})
export class ComissionComponent {

    @Input() info : any;

    constructor( 
        protected vs: ViewService
    ){
    }

    callback(data){
        this.vs.setCallback(data);
    }

}